import { useEffect } from 'react';

const PWAInstallPrompt = () => {
  // Disable PWA install to prevent Google Play Protect warnings
  useEffect(() => {
    const handler = (e) => { e.preventDefault(); };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  return null;
};

export default PWAInstallPrompt;
